<template>
    <v-card width="600" class="mx-auto ma-4">
        <v-card-title>
            Stationer
        </v-card-title>
        <v-card-text>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Namn</th>
                            <th class="text-right">Användare</th>
                            <th class="text-left">Utgång</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="station in stations" :key="station._key">
                            <td>{{ station.name }}</td>
                            <td class="text-right">{{ station.users.length }}</td>
                            <td>{{ new Date(station.licenseDueDate.seconds*1000).humanDate() }}</td>
                            <td>
                                <v-icon>mdi-pencil-outline</v-icon>
                            </td>
                            <td>
                                <v-icon>mdi-trash-can-outline</v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card-text>
        <v-divider />
        <v-card-actions v-if="showAddButton" class="pa-2">
            <v-spacer />
            <v-btn>Lägg till station</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
// import VueFirestore from 'vue-firestore'

// Vue.use(VueFirestore)

export default {
    name: "StationList",
    props: {
        'db': Object,
        'showAddButton': Boolean,
    },
    firestore () {
        return {
            // Collection
            stations: window.db.collection('stations'),
        }
    },
}
</script>

<style>

</style>